import { render } from "./Index.vue?vue&type=template&id=686338da"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Home/Partners/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "686338da"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('686338da', __exports__)) {
    api.reload('686338da', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=686338da", () => {
    api.rerender('686338da', render)
  })

}


export default __exports__